import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { KanbanBoardService } from '@services/lm/kanban-board.service';
import { TaskLabel } from '@app/interfaces/lm/kanban-board';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConfirmationService } from '@services/sys/confirmation.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSelectComponent } from 'ng-zorro-antd/select';

@Component({
    selector: 'app-label-select',
    templateUrl: './label-select.component.html',
    styleUrl: './label-select.component.less',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LabelSelectComponent),
            multi: true,
        },
    ],
})
export class LabelSelectComponent implements OnInit {
    @ViewChild('selectComponent') selectComponent!: NzSelectComponent;
    @Input() clickToEdit = false; // 点击后才编辑
    @Input() formControlName = '';
    @Input() required = false;
    @Input() value: string[] = [];
    @Input() showAdd = false;
    @Input() inactiveUsers: boolean = false;
    @Output() valueChange = new EventEmitter();

    options: TaskLabel[] = [];
    addLoading = false;
    loading = false;

    isEditing = false;
    lastValue: string[] = [];
    openMenu = false;
    labelInfos: {
        [labelId: string]: TaskLabel
    } = {};
    currentValue: string[] = [];

    constructor(private kanbanBoardService: KanbanBoardService,
                private message: NzMessageService,
                private confirmationService: ConfirmationService) {
    }

    onChange: any = () => {
    };
    onTouch: () => void = () => null;

    async ngOnInit(): Promise<void> {
        this.currentValue = this.value || [];
        await this.fetchTaskLabel();
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    writeValue(obj: any): void {
        this.value = obj || [];
        this.currentValue = this.value || [];
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    changeSelect(arr: string[]): void {
        if (this.clickToEdit && this.required && (!arr || arr.length === 0)) {
            this.message.error('This field is required');
            return;
        }
        this.onChange(this.currentValue);
    }

    async fetchTaskLabel(): Promise<void> {
        try {
            this.loading = true;
            this.options = await this.kanbanBoardService.getAllTaskLabel();
            let data = {};
            this.options.forEach(it => {
                data = {
                    ...data,
                    [it.id]: it
                };
            });
            this.labelInfos = data;
        } finally {
            this.loading = false;
        }
        console.log('typeOptions', this.options);
    }

    getColor(labelId: string): string {
        const item = this.options.find(it => it.id === labelId);
        return item ? item.color : '';
    }

    async handleAdd(labelNameEl: any, labelColorEl: any): Promise<void> {
        try {
            if(labelNameEl.value.length > 20) {
                this.message.error('Label name should be less than 20 characters');
                return;
            }
            const labelName = labelNameEl.value;
            const color = labelColorEl.blockColor;
            if (!color) {
                this.message.error('Please select label color');
                return;
            }
            if (!labelName) {
                this.message.error('Please input label name');
                return;
            }
            this.addLoading = true;
            await this.kanbanBoardService.addTaskLabel({
                color,
                labelName,
            });
            await this.fetchTaskLabel();
            labelNameEl.value = '';
        } finally {
            this.addLoading = false;
        }
    }

    startEditing(): void {
        if (!this.clickToEdit) {
            return;
        }
        this.currentValue = this.value || [];
        this.lastValue = [...this.currentValue] as string[];
        this.isEditing = true;
        setTimeout(() => {
            this.selectComponent.focus();
            this.openMenu = true;
        }, 200);
    }

    changeValue(): void {
        const sortedCurrent = [...this.currentValue].sort();
        const sortedInitial = [...this.value].sort();
        if (JSON.stringify(sortedCurrent) === JSON.stringify(sortedInitial)) {
            this.isEditing = false;
            this.openMenu = false;
            return;
        }
        else {
            this.confirmationService.confirmUpdateTask(this.inactiveUsers, () => {
                setTimeout(() => {
                    if (JSON.stringify(this.lastValue) !== JSON.stringify(this.currentValue)) {
                        this.valueChange.emit(this.currentValue);
                    }
                }, 400);
                }, () => { this.handleCancel(); }
            );
        }
    }

    openChange(visible: boolean): void {
        if (!this.clickToEdit) {
            return;
        }
        if (this.required && (!this.currentValue || this.currentValue.length === 0)) {
            this.currentValue = this.value;
        }
        this.changeValue();
        if (!visible && this.isEditing) {
            this.isEditing = false;
        }
    }

    handleCancel(): void {
        this.currentValue = this.lastValue;
        this.openMenu = false;
        this.isEditing = false;
    }

    closeDropdown(): void {
        this.openMenu = false;
        this.selectComponent?.setOpenState(false);
    }
}
